/**
 * Cookie utilities for anonymous journey identification.
 * No PII is stored in the cookie – only a random UUID to link the browser to an in-progress journey.
 */
const COOKIE_MAX_AGE_DAYS = 30;

/**
 * Get the value of a cookie by name.
 * @param {string} name
 * @returns {string|null}
 */
export function getCookie(name) {
  if (typeof document === 'undefined') return null;
  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  return match ? decodeURIComponent(match[2]) : null;
}

/**
 * Set a cookie (path=/, sameSite=Lax, maxAge=30 days).
 * @param {string} name
 * @param {string} value
 * @param {number} maxAgeDays
 */
export function setCookie(name, value, maxAgeDays = COOKIE_MAX_AGE_DAYS) {
  if (typeof document === 'undefined') return;
  const maxAge = maxAgeDays * 24 * 60 * 60;
  document.cookie = `${name}=${encodeURIComponent(value)};path=/;max-age=${maxAge};SameSite=Lax`;
}

